function getEaster(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, month - 1, day);
}

function toISO(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);

  return result;
}

function getHolidaysForYear(year) {
  const easter = getEaster(year);
  const fixed = [
    { date: `${year}-01-01`, title: "Confraternizacao Universal" },
    { date: `${year}-04-21`, title: "Tiradentes" },
    { date: `${year}-05-01`, title: "Dia do Trabalho" },
    { date: `${year}-09-07`, title: "Independencia do Brasil" },
    { date: `${year}-10-12`, title: "Nossa Senhora Aparecida" },
    { date: `${year}-11-02`, title: "Finados" },
    { date: `${year}-11-15`, title: "Proclamacao da Republica" },
    { date: `${year}-11-20`, title: "Dia da Consciencia Negra" },
    { date: `${year}-12-25`, title: "Natal" },
  ];
  const movable = [
    { date: toISO(addDays(easter, -48)), title: "Carnaval" },
    { date: toISO(addDays(easter, -47)), title: "Carnaval" },
    { date: toISO(addDays(easter, -2)), title: "Sexta-feira Santa" },
    { date: toISO(addDays(easter, 60)), title: "Corpus Christi" },
  ];

  return [...fixed, ...movable].sort((a, b) => a.date.localeCompare(b.date));
}

function generateHolidays() {
  const currentYear = new Date().getFullYear();
  const all = [];

  for (let year = currentYear - 1; year <= currentYear + 5; year += 1) {
    all.push(...getHolidaysForYear(year));
  }

  return all;
}

const HOLIDAY_MAP = new Map(generateHolidays().map((holiday) => [holiday.date, holiday]));

export const getHolidayByDate = (dateStr) => HOLIDAY_MAP.get(dateStr);
